import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Descriptions, Divider, Form, Modal, Table } from 'antd';
import DirectRenewalForm from '../../views/certificates/certificateDetails/directRenewalForm';
import { formatDateDisplay } from '../../utils/commonUtil';
const DirectCertRenewalModal = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    const items = [];
    if ((_a = props.data) === null || _a === void 0 ? void 0 : _a.strServiceName) {
        items.push({
            key: 'strServiceName',
            label: 'Certificate Name',
            children: (_b = props.data) === null || _b === void 0 ? void 0 : _b.strServiceName,
            span: { xl: 1, xxl: 1 }
        });
    }
    if ((_c = props.data) === null || _c === void 0 ? void 0 : _c.strCertId) {
        items.push({
            key: 'strCertId',
            label: 'Certificate Id',
            children: (_d = props.data) === null || _d === void 0 ? void 0 : _d.strCertId,
            span: { xl: 1, xxl: 1 }
        });
    }
    if ((_e = props.data) === null || _e === void 0 ? void 0 : _e.dtCertDate) {
        items.push({
            key: 'dtCertDate',
            label: 'Issue Date',
            children: formatDateDisplay((_f = props.data) === null || _f === void 0 ? void 0 : _f.dtCertDate),
            span: { xl: 1, xxl: 1 }
        });
    }
    if ((_g = props.data) === null || _g === void 0 ? void 0 : _g.dtCertExpDate) {
        items.push({
            key: 'dtCertExpDate',
            label: 'Expiration Date',
            children: formatDateDisplay((_h = props.data) === null || _h === void 0 ? void 0 : _h.dtCertExpDate),
            span: { xl: 1, xxl: 1 }
        });
    }
    if ((_k = (_j = props.data) === null || _j === void 0 ? void 0 : _j.objCertStatus) === null || _k === void 0 ? void 0 : _k.strLongDesc) {
        items.push({
            key: 'objCertStatus',
            label: 'Certificate Status',
            children: (_m = (_l = props.data) === null || _l === void 0 ? void 0 : _l.objCertStatus) === null || _m === void 0 ? void 0 : _m.strLongDesc,
            span: { xl: 1, xxl: 1 }
        });
    }
    if ((_p = (_o = props.data) === null || _o === void 0 ? void 0 : _o.objCertRenewalStatus) === null || _p === void 0 ? void 0 : _p.strLongDesc) {
        items.push({
            key: 'objCertRenewalStatus',
            label: 'Renewal Status',
            children: (_r = (_q = props.data) === null || _q === void 0 ? void 0 : _q.objCertRenewalStatus) === null || _r === void 0 ? void 0 : _r.strLongDesc,
            span: { xl: 1, xxl: 1 }
        });
    }
    if ((_s = props.data) === null || _s === void 0 ? void 0 : _s.dtRenewalDate) {
        items.push({
            key: 'dtRenewalDate',
            label: 'Recommended Decision Date',
            children: formatDateDisplay((_t = props.data) === null || _t === void 0 ? void 0 : _t.dtRenewalDate),
            span: { xl: 1, xxl: 1 }
        });
    }
    const columns = [
        {
            title: 'Product Model (Series Model)',
            dataIndex: 'strSeriesModel',
            key: 'strSeriesModel',
            width: '30%'
        },
        {
            title: 'Brand/OEM',
            dataIndex: ['objBrandName', 'strLongDesc'],
            key: 'objBrandName',
            width: '30%'
        }
    ];
    return (_jsx(Modal, { title: 'Link Renewal Certificate (Add Renewal Certificates)', open: props.open, onCancel: props.onClose, width: 1000, footer: "", children: _jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsx(Descriptions, { title: "Previous Certificate Information", size: "small", layout: "vertical", bordered: true, labelStyle: { fontWeight: 'bold' }, items: items, column: { xs: 1, sm: 1, md: 3, lg: 3, xl: 7, xxl: 7 } }), _jsx(Divider, {}), _jsxs(Form, { form: props.form, layout: "vertical", name: "Certificate-form", onFinish: props.onFinish, children: [_jsx(DirectRenewalForm, { data: props.data }), _jsxs(Form.Item, { children: [((_u = props === null || props === void 0 ? void 0 : props.data) === null || _u === void 0 ? void 0 : _u.boolSingleCert) ? (_jsxs(_Fragment, { children: [_jsx(Divider, { orientation: 'left', children: "Series Model Information" }), _jsx(Table, { columns: columns, dataSource: props.productFamilyList })] })) : (''), _jsx("div", { style: { textAlign: 'center', marginTop: '15px' }, children: _jsx(Button, { type: "primary", htmlType: "submit", children: "Submit" }) })] })] })] }) }));
};
export default DirectCertRenewalModal;
